import { Component, OnInit, Inject, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { UpdatePermissionViewModel } from 'src/app/viewModels/permissions/updatePermissionViewModel/update-permission-view-model';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { CommonService } from 'src/app/middleware/common/common.service';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import { PermissionService } from '../services/permission/permission.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';

@Component({
  selector: 'app-edit-permissions',
  templateUrl: './edit-permissions.component.html',
  styleUrls: ['./edit-permissions.component.scss']
})
export class EditPermissionsComponent implements OnInit {

  constructor(private updatePermissionVM: UpdatePermissionViewModel, private fb: FormBuilder,
    private permissionService: PermissionService, private toastr: ToastrService,
    private statusConst: StatusConstant, private loader: LoaderService,
    private commonService: CommonService,private paginationVM: PaginationViewModel,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,) {

      const encryptedtoken = sessionStorage.getItem('userToken');
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);

    this.updatePermissionDetailform = this.fb.group({
      permissionName: ['', Validators.required],
      permissionDescription: ['', Validators.required],
      permissionAdd: [''],
      permissionEdit: [''],
      permissionDelete: [''],
      moduleSelected: ['',Validators.required],
      //isActive: ['']
    });
    let data = [];
    data = this.commonService.getEditData();
    if(data !=null){
    
    this.isEdit = data[0];
    this.permission = data[1];
    
    this.updatePermissionDetail.description = this.permission.description;
    this.updatePermissionDetail.permissionName = this.permission.permissionName;
    this.updatePermissionDetail.permissionID = this.permission.permissionID;
    this.updatePermissionDetail.addPermission = this.permission.addPermission;
    this.updatePermissionDetail.editPermission = this.permission.editPermission;
    this.updatePermissionDetail.deletePermission = this.permission.deletePermission;
    this.updatePermissionDetail.moduleId = this.permission.moduleID;
    this.updatePermissionDetail.isActive = true;
    }
  }
  


  updatePermissionDetailform: FormGroup;
  updatePermissionDetail: UpdatePermissionViewModel = new UpdatePermissionViewModel();
  isEdit: boolean;
  permission: any;
  ModuleListResponseHolder: any;
  ModuleList: any;
  updatePermissionResponseHolder: any;
  buttonDisabled:boolean=true;
  databaseId: string;
  organizationId: string;
  currentUser: any;
  @Output() closeSidePanel = new EventEmitter();
  

  ngOnInit(): void {
    this.paginationVM.pageIndex = 1; 
    this.getModuleList();
    this.buttonDisabled =true;
  }

  close() {
    let closePanel = false;
    this.closeSidePanel.emit(closePanel);
  }

  
  getModuleList() {
    let pagesize = this.paginationVM.pageSize;
    this.paginationVM.pageSize = 10000;
    this.permissionService.getModuleList(this.paginationVM).subscribe(response => {
      if (response != undefined) {
        this.ModuleListResponseHolder = response;
        this.ModuleList = this.ModuleListResponseHolder.data;       
      }
    });
     this.paginationVM.pageSize= pagesize;
  }

  updatePermission() {
    let updateSelectedDetail = new UpdatePermissionViewModel();
    updateSelectedDetail = this.updatePermissionDetail;
    updateSelectedDetail.organizationID=Number(this.organizationId);    
    this.loader.show();
    this.permissionService.updatePermission(this.updatePermissionDetail).subscribe(response => {
      this.updatePermissionResponseHolder = response;
      this.loader.hide();
      if (this.updatePermissionResponseHolder.status === this.statusConst.statusSuccess) {
        let closePanel = true;
        this.closeSidePanel.emit(closePanel);
        this.toastr.success("Permission updated successfully.", '', {
          timeOut: 3000,
        });       
      } else {
        this.toastr.error(this.updatePermissionResponseHolder.message, '', {
          timeOut: 3000,
        });
      }
    });
  }

  Textboxchange(newValue) {
    this.buttonDisabled =false;
  }

  CheckBoxclick(ev){
    this.buttonDisabled =false;
 }

 onDrpChange(ob) {
   this.buttonDisabled =false;
  }

}
